// extracted by mini-css-extract-plugin
export default {"VotingLike_Wrapper":"ThumbUp_VotingLike_Wrapper__-OttI","likeAmount":"ThumbUp_likeAmount__0RAWf","ThumbUp_Btn":"ThumbUp_ThumbUp_Btn__MgFmb","active":"ThumbUp_active__lodqb"};